import script from "./ActiveAccountBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActiveAccountBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ActiveAccountBtn.vue?vue&type=style&index=0&id=eea2ee30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eea2ee30"]])

export default __exports__